import { Pipe, PipeTransform } from '@angular/core';
import { DiscussionPluginService } from './discussion-plugin.service';

@Pipe({
    name: 'discussioncommenttype',
    standalone: false
})
export class DiscussionCommentTypePipe implements PipeTransform {
  public types: any;

  constructor(private service: DiscussionPluginService) {
    this.types = this.service.getTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.types);
  }
}
